module.exports = __webpack_public_path__ + "static/media/1.cd6b13ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/1.jpg
// module id = 162
// module chunks = 0